module.exports = __webpack_public_path__ + "img/00002.ad411674.webp";